import React, { FC, ReactElement } from 'react';
import type { Route } from 'next';
import Link from 'next/link';
import classNames from 'classnames/bind';
import Breadcrumbs from 'components/Breadcrumbs';
import { Statistics } from 'sections/Home/components/Statistics';
import { IconDownload } from 'sections/Company/VisionStrategy/components/Svg';
import styles from 'sections/Company/VisionStrategy/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

interface SectionHeaderProps {
  membersQuantity: number;
};

const SectionHeader: FC<SectionHeaderProps> = ({ membersQuantity }): ReactElement => {
  return (
    <section className={cn('header')}>

      {/* Breadcrumbs */}
      <div className={cn('container')}>
        <Breadcrumbs
          mTop={64}
          mode="light"
          links={[{ title: 'Vision Strategy', href: '' as Route }]}
        />
      </div>

      {/* Content */}
      <div className={cn('container', 'content')}>

        <div className={cn('header__image-container')}>
          <picture>
            <source
              srcSet="
                /images/pages/Company/VisionAndStrategy/planet.webp 1x,
                /images/pages/Company/VisionAndStrategy/planet@2x.webp 2x
              "
              sizes='100vw'
            />
            <img
              className={cn('header__image')}
              src='/images/pages/Company/VisionAndStrategy/planet.webp'
              alt='Digital Freight Members'
            />
          </picture>
        </div>

        <div className={cn('header__content')}>
          <div className={cn('header__heading-container')}>
            <span className={cn('header__heading-label')}>Digital Freight Alliance</span>

            <h1 className={cn('header__heading')}>Vision & Strategy</h1>

            <p className={cn('header__heading-description')}>
              The DFA is a network association designed to connect{' '}
              <Link className={cn('header__heading-link')} href='/freight-forwarder'>
                freight forwarders
              </Link>{' '}
              to each other and to cargo opportunities. Uniquely among such associations this design is part of a wider
              vision to facilitate digital transformation for members, by providing the best on-line digital tools and
              access to a dynamic cargo booking platform.
            </p>
          </div>

          <div className={cn('header__buttons')}>
            <a
              className={cn('header__button-download')}
              href='/download/Company/VisionAndStrategy/dfa_members_kit.pdf'
              download
            >
              {IconDownload}
              <span>Membership Guide</span>
            </a>
          </div>

          <div className={cn('header__bottom')}>
            <div className={cn('header__statistics-container')}>
              <Statistics membersQuantity={membersQuantity} />
            </div>
            <div className={cn('header__bottom-image-container')}>
              <picture>
                <source
                  srcSet="
                /images/pages/Company/VisionAndStrategy/mission.webp 1x,
                /images/pages/Company/VisionAndStrategy/mission@2x.webp 2x
              "
                  sizes='100vw'
                />
                <img
                  className={cn('header__bottom-image')}
                  src='/images/pages/Company/VisionAndStrategy/mission.webp'
                  alt='Digital Freight Members'
                />
              </picture>
            </div>
          </div>
        </div>

      </div>

    </section>
  );
};

export default SectionHeader;